module.exports = __webpack_public_path__ + "img/tool-data-base.e42b4cbf.svg";